var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoselectedvideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_4630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.125 80.625L67.75 19C67.0625 18.8125 66.375 18.75 65.625 18.75H9.375C4.1875 18.75 0 22.9375 0 28.125V71.875C0 75.9375 2.5625 79.375 6.125 80.625ZM95.5 25.3125L75 35.5625V29.4188L99.0875 5.33125C99.6567 4.74187 99.9717 3.95249 99.9646 3.13312C99.9575 2.31376 99.6288 1.52997 99.0494 0.95057C98.47 0.371169 97.6862 0.0425165 96.8669 0.0353965C96.0475 0.0282764 95.2581 0.343259 94.6688 0.912503L0.91875 94.6625C0.349506 95.2519 0.0345236 96.0413 0.0416436 96.8606C0.0487637 97.68 0.377417 98.4638 0.956817 99.0432C1.53622 99.6226 2.32001 99.9512 3.13937 99.9584C3.95874 99.9655 4.74812 99.6505 5.3375 99.0813L23.1688 81.25H65.625C70.8125 81.25 75 77.0625 75 71.875V64.4375L95.5 74.6875C95.9718 74.9147 96.4924 75.0222 97.0156 75.0004C97.5389 74.9786 98.0487 74.8282 98.5 74.5625C99.4375 73.9375 100 72.9375 100 71.875V28.125C99.9915 27.588 99.8501 27.0614 99.5883 26.5924C99.3265 26.1234 98.9526 25.7266 98.5 25.4375C98.0541 25.1573 97.5428 24.9984 97.0166 24.9765C96.4904 24.9546 95.9677 25.0704 95.5 25.3125Z",
    fill: "#5A53DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_4630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoselectedvideo);
export default __webpack_public_path__ + "static/media/noselectedvideo.ed3b30884d3ed2ab4304e39d9d3e1278.svg";
export { ForwardRef as ReactComponent };